import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { DataService } from 'src/app/_services/data.service';
import { IPermission, User } from 'src/app/_models/user';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

var misc: any = {
  sidebar_mini_active: true,
};

export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  authRequired?: boolean;
  icontype: string;
  collapse?: string;
  isCollapsed?: boolean;
  isCollapsing?: any;
  children?: ChildrenItems[];
  external?: boolean;
}

export interface ChildrenItems {
  path: string;
  title: string;
  type?: string;
  collapse?: string;
  children?: ChildrenItems2[];
  isCollapsed?: boolean;
}
export interface ChildrenItems2 {
  path?: string;
  title?: string;
  type?: string;
}

let filteredMenuItem: any[];

//Menu Items
export const ROUTES: RouteInfo[] = [
  // {
  //   path: 'dashboard',
  //   title: 'Dashboard',
  //   authRequired: true,
  //   type: 'link',
  //   icontype: 'fas fa-chart-pie text-primary',
  // },
  {
    path: 'report-generator',
    title: 'Report Generator',
    authRequired: true,
    type: 'link',
    icontype: 'fas fa-chart-line text-primary',
  },
  {
    path: 'dashboards',
    title: 'Dashboards',
    authRequired: true,
    type: 'link',
    icontype: 'fas fa-th-large text-primary',
  },
  // {
  //   title: 'Automations',
  //   type: 'link',
  //   icontype: 'fas fa-bolt text-primary',
  //   path: 'automations',
  // },
  // {
  //   path: '',
  //   title: 'Reports',
  //   type: 'sub',
  //   icontype: 'fas fa-clipboard text-primary',
  //   collapse: 'reports',
  //   isCollapsed: false,
  //   children: [
  //     { path: 'reports', title: 'View Reports', type: 'link' },
  //     { path: 'reports/builder', title: 'Report Builder', type: 'link' },
  //     // { path: 'dashboards', title: 'Dashboard Builder', type: 'link' },
  //   ],
  // },
  {
    path: '',
    title: 'App Development',
    type: 'sub',
    icontype: 'fas fa-hammer text-primary',
    collapse: 'components',
    isCollapsed: false,
    children: [
      { path: 'spaces', title: 'Spaces', type: 'link' },
      { path: 'assets', title: 'Assets', type: 'link' },
      { path: 'asset-tree', title: 'Asset Graph', type: 'link' },
      { path: 'events', title: 'Events', type: 'link' },
    ],
  },
  {
    path: '',
    title: 'Network',
    type: 'sub',
    icontype: 'fas fa-broadcast-tower text-primary',
    collapse: 'components',
    isCollapsed: false,
    children: [
      { path: 'gateways', title: 'Gateways', type: 'link' },
      { path: 'devices', title: 'Devices', type: 'link' },
    ],
  },
  {
    path: '',
    title: 'System',
    type: 'sub',
    icontype: 'fas fa-sliders-h text-primary',
    collapse: 'components',
    isCollapsed: false,
    children: [
      { path: 'settings', title: 'Settings', type: 'link' },
      { path: 'features', title: 'Features', type: 'link' },
      { path: 'users', title: 'Users', type: 'link' },
    ],
  },
];

export const SUPERUSER_ROUTES: RouteInfo[] = [
  {
    path: 'device-library',
    title: 'Device Library',
    authRequired: false,
    type: 'link',
    icontype: 'fas fa-book text-primary',
  },
  {
    path: 'https://console.semvar.com',
    title: 'Management Console',
    authRequired: false,
    type: 'link',
    icontype: 'fas fa-cog text-primary',
    external: true,
  },
  {
    path: 'https://docs.semvar.com/',
    title: 'Documentation',
    authRequired: false,
    type: 'link',
    icontype: 'fas fa-book text-primary',
    external: true,
  },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent implements OnInit, OnDestroy {
  public menuItems = [];
  public superUserMenuItems = [];
  public isCollapsed = true;
  currentUser: User;
  superuser = true;
  settings;
  apiHealth;
  sub$ = new Subscription();
  permissions$: Observable<IPermission>;
  logo = environment.envVar.LOGO;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private dataService: DataService
  ) {
    const userSub$ = this.authenticationService.currentAccountValue.subscribe(
      user => {
        if (user) this.currentUser = user;
        this.permissions$ =
          this.authenticationService.permissions$.asObservable();
      }
    );
    const healthSub$ = this.dataService.getHealth().subscribe((data: any) => {
      if (data) this.apiHealth = data;
    });
    this.sub$.add(userSub$);
    this.sub$.add(healthSub$);
  }

  ngOnDestroy() {
    this.sub$.unsubscribe();
  }

  ngOnInit() {
    ROUTES.forEach(menuItem => {
      if (menuItem.children) {
        let filteredMenuItem = Object.assign({}, menuItem);
        filteredMenuItem.children = [];
        menuItem.children.forEach(subMenuItem => {
          filteredMenuItem.children.push(subMenuItem);
        });
        this.menuItems.push(filteredMenuItem);
      } else {
        this.menuItems.push(menuItem);
      }
    });
    SUPERUSER_ROUTES.forEach(menuItem => {
      this.superUserMenuItems.push(menuItem);
    });
    this.router.events.subscribe(event => {
      this.isCollapsed = true;
    });
  }

  onMouseEnterSidenav() {
    if (!document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.add('g-sidenav-show');
    }
  }
  onMouseLeaveSidenav() {
    if (!document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-show');
    }
  }
  minimizeSidebar() {
    const sidenavToggler =
      document.getElementsByClassName('sidenav-toggler')[0];
    const body = document.getElementsByTagName('body')[0];
    if (body.classList.contains('g-sidenav-pinned')) {
      misc.sidebar_mini_active = true;
    } else {
      misc.sidebar_mini_active = false;
    }
    if (misc.sidebar_mini_active === true) {
      body.classList.remove('g-sidenav-pinned');
      body.classList.add('g-sidenav-hidden');
      sidenavToggler.classList.remove('active');
      misc.sidebar_mini_active = false;
    } else {
      body.classList.add('g-sidenav-pinned');
      body.classList.remove('g-sidenav-hidden');
      sidenavToggler.classList.add('active');
      misc.sidebar_mini_active = true;
    }
  }
}
